import React from 'react';
import { Link, LinkProps } from '@mui/material';
import { YoutubeReadyLink } from './YoutubeReadyLink';
import { Mp3ReadyLink } from './MP3Link';
import { parseYoutubeLink } from "./youtubeLinkParser";

export const MediaLink = (props: LinkProps) => {
  const youtubeLinkParams = props.href ? parseYoutubeLink(props.href) : null;
  const isMp3 = props.href?.endsWith('.mp3');

  if (youtubeLinkParams) {
    return (
      <YoutubeReadyLink
        videoId={youtubeLinkParams.videoId}
        timestampInSec={youtubeLinkParams.timestampInSec}
        {...props}
      />
    );
  } else if (isMp3) {
    return <Mp3ReadyLink {...props} />;
  } else {
    return <Link {...props} />;
  }
};


